import React from "react";
import { Route } from "react-router-dom";
import { MainReport, ReportMainIndex } from "../Views/Web/Report";
import ProcurementReportLayout from "../Views/Web/Report/Components/Procurement/ProcurementReportLayout";
import SalesReportLayout from "../Views/Web/Report/Components/Sales/SalesReportLayout";
import CostSaving from "../Views/Web/Report/Components/Procurement/CostSaving/CostSaving";
import PurchaseOrder from "../Views/Web/Report/Components/Procurement/PurchaseOrder/PurchaseOrder";
import YPRReport from "../Views/Web/Report/Components/Procurement/YPR/YPRReport";
import RFQReport from "../Views/Web/Report/Components/Procurement/RFQ/RFQReport";
import CustomerQuoteReport from "../Views/Web/Report/Components/Sales/CustomerQuote/CustomerQuoteReport";

function ReportRoutes() {
  return (
    <Route path="reports" element={<MainReport />}>
      <Route index element={<ReportMainIndex />} />
      <Route path="procurement" element={<ProcurementReportLayout />}>
        <Route path="cost-saving-analysis" element={<CostSaving />} />
        <Route path="purchase-order" element={<PurchaseOrder />} />
        <Route path="ypr" element={<YPRReport />} />
        <Route path="rfq" element={<RFQReport />} />
      </Route>
      <Route path="sales" element={<SalesReportLayout />}>
        <Route path="customer-quote" element={<CustomerQuoteReport />} />
      </Route>
    </Route>
  );
}

export default ReportRoutes;
